import LoginLayout from '../../../layouts/LoginLayout'
import ForgotPassword from './ForgotPassword'

export default LoginLayout(ForgotPassword)